import { render, staticRenderFns } from "./SimilarProperties.vue?vue&type=template&id=f038607a"
import script from "./SimilarProperties.vue?vue&type=script&lang=ts"
export * from "./SimilarProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports